import { render, staticRenderFns } from "./DashboardLomPresident.vue?vue&type=template&id=17126d66"
import script from "./DashboardLomPresident.vue?vue&type=script&lang=js"
export * from "./DashboardLomPresident.vue?vue&type=script&lang=js"
import style0 from "./DashboardLomPresident.vue?vue&type=style&index=0&id=17126d66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports